<template>
  <div data-component="Widget/Radio">
    <input 
      type="radio" 
      :name="name" 
      :id="id" 
      :value="value"
      v-bind="$attrs"
      @input="$emit('update:modelValue', $event.target.value)"
    />
    <label :for="id">{{ label }}</label>
    <div class="checker">
      <div class="circle-button" />
    </div>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Radio',
  props: {
    label: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Number, Boolean],
      default: ''
    },
    modelValue: {
      type: [String, Number, Boolean],
      default: ''
    }
  },
  emits: ['update:modelValue']
}
</script>

<style lang="scss" scoped>
// Styles are now in src/assets/styles/components/Widget.scss (global)
</style>
